export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5274.4185dae8.jpg";